import { render, staticRenderFns } from "./EditRoleRow.vue?vue&type=template&id=daa7f9b2&scoped=true&"
import script from "./EditRoleRow.vue?vue&type=script&lang=js&"
export * from "./EditRoleRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa7f9b2",
  null
  
)

export default component.exports